import { pingServer } from "../apiClient.js";

const autoRetrySeconds = 15;

function buildInfoView({ icon, heading, text, retryText, retryHref, onRetry }) {
    const content = document.querySelector("#content");
    if (!content) return null;

    content.replaceChildren();

    const wrapper = document.createElement("div");
    wrapper.className = "offlineView";

    const iconEl = document.createElement("div");
    iconEl.className = "offlineViewIcon";
    iconEl.innerHTML = icon;

    const headingEl = document.createElement("h2");
    headingEl.textContent = heading;

    const textEl = document.createElement("p");
    text.split("\n").forEach((line, i) => {
        if (i > 0) textEl.appendChild(document.createElement("br"));
        textEl.appendChild(document.createTextNode(line));
    });

    wrapper.append(iconEl, headingEl, textEl);

    let retryButton = null;
    if (retryText) {
        retryButton = document.createElement("button");
        retryButton.className = "offlineViewRetry";
        retryButton.textContent = retryText;
        retryButton.addEventListener("click", onRetry ?? (() => {
            if (retryHref) window.location.href = retryHref;
            else window.location.reload();
        }));
        wrapper.append(retryButton);
    }

    content.appendChild(wrapper);
    return { wrapper, retryButton };
}

let stopActiveOfflineCheck = null;

export function showOfflineView() {
    stopActiveOfflineCheck?.();

    const { wrapper, retryButton } = buildInfoView({
        icon: '<i class="fa-solid fa-triangle-exclamation"></i>',
        heading: "Server nicht erreichbar",
        text: "Die Verbindung zum Server konnte nicht hergestellt werden.\nDas kann an deiner Internetverbindung liegen oder daran, dass der Dienst gerade nicht verfügbar ist.",
        retryText: "Erneut versuchen",
        onRetry: () => runCheck()
    });

    const statusEl = document.createElement("div");
    statusEl.className = "offlineViewStatus";
    const dotEl = document.createElement("span");
    dotEl.className = "offlineViewStatusDot";
    const statusTextEl = document.createElement("span");
    statusEl.append(dotEl, statusTextEl);
    retryButton.before(statusEl);

    const countdownEl = document.createElement("p");
    countdownEl.className = "offlineViewCountdown";
    wrapper.append(countdownEl);

    let stopped = false;
    let intervalId = null;
    let secondsLeft = autoRetrySeconds;

    function setChecking(isChecking) {
        dotEl.classList.toggle("offlineViewStatusDot--checking", isChecking);
        statusTextEl.textContent = isChecking
            ? "Verbindung wird geprüft ..."
            : `Zuletzt geprüft: ${new Date().toLocaleTimeString("de-DE")}`;
        retryButton.disabled = isChecking;
    }

    function tick() {
        secondsLeft -= 1;
        if (secondsLeft <= 0) runCheck();
        else countdownEl.textContent = `Nächster automatischer Versuch in ${secondsLeft}s`;
    }

    async function runCheck() {
        if (stopped) return;

        clearInterval(intervalId);
        setChecking(true);
        countdownEl.textContent = "";

        const reachable = await pingServer();
        if (stopped) return;

        if (reachable) {
            window.location.reload();
            return;
        }

        setChecking(false);
        secondsLeft = autoRetrySeconds;
        countdownEl.textContent = `Nächster automatischer Versuch in ${secondsLeft}s`;
        intervalId = setInterval(tick, 1000);
    }

    stopActiveOfflineCheck = () => {
        stopped = true;
        clearInterval(intervalId);
    };

    runCheck();
}

export function showNotRegisteredView() {
    buildInfoView({
        icon: '<i class="fa-solid fa-lock"></i>',
        heading: "Nicht registriert",
        text: "Du bist noch nicht im TimeTrackingTool registriert. Bitte wende dich an einen Administrator, damit dein Konto angelegt wird.",
        retryText: "Erneut versuchen"
    });
}

export function showInvalidSessionView(loginHref) {
    buildInfoView({
        icon: '<i class="fa-solid fa-triangle-exclamation"></i>',
        heading: "Sitzung abgelaufen",
        text: "Deine Sitzung ist abgelaufen oder ungültig. Bitte melde dich erneut an.",
        retryText: "Erneut anmelden",
        retryHref: loginHref
    });
}